import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Ladybug } from "@/components/site/Ladybug";

const MODULES = [
  ["1", "Getting Yourself in Order: Mind, Body, Spirit & Home", [
    "The Holistic Audit: Coming Into Full Awareness",
    "House Check 1-2, 1-2: Your Personal House Call",
    "Finding the Condition: Divination as Diagnosis",
    "Meditation for Release: Letting Go What No Longer Serves",
    "Uncrossing Yourself: Cord-Cutting & Personal Clearing",
    "Blessing Your Home & Your Forward Path",
  ]],
  ["3", "Your Sacred Calendar & Chakra System", [
    "Your Chakra System: Internal & External Connections",
    "Building a Calendar That Actually Works for You",
    "Money Dates, Paid-in-Full Energy & Abstract Writing",
    "Prayers, Affirmations & the Power of Spoken Word",
    "Spiritual Baths for Every Occasion",
  ]],
  ["4", "The Spiritual Home-Care Loop & Sacred Space", [
    "The Spiritual Home-Care Loop: Your Routine Schedule",
    "Floor Washes, Door Protections & Window Care",
    "Feng Shui Basics & the Bagua Map",
    "Bringing the Gods to Your Feet: Altar Work & Divine Invocation",
  ]],
  ["5", "The Home Herbal Apothecary", [
    "Herbs You Should Always Have at Home",
    "Deep Dive: Using Herbs as Physical Medicine",
    "Deep Dive: Using Herbs in Your Spiritual Healing Practice",
    "Seasonal Medicine-Making: Preparations to Store Ahead",
  ]],
  ["6", "Body Therapies, Digestive Health & Feminine Wellness", [
    "Yoni Steams: Recipes, Protocols & Benefits",
    "Castor Oil Packs: Methods, Recipes & Therapeutic Uses",
    "Digestive Health Remedies & Gut-Healing Recipes",
    "Minerals & Vitamins for Women's Health",
  ]],
  ["7", "Food Therapy & Healing Lifestyle Choices", [
    "Food as Medicine: The Philosophy Behind Food Therapy",
    "Healing Fasts: Protocols, Purpose & Who They're For",
    "Healthy Lifestyle Menus: Seasonal & Family Healing Meals",
  ]],
  ["8", "The Birthworker & Holistic Family Practitioner", [
    "Introduction to Birthwork: Roles, Scope & Sacred Purpose",
    "Consultations: Structure, Ethics & Client Care",
    "Pricing Your Services & Building Your Practice",
    "Your Cosmic Blueprint: Mapping Your Path as a Practitioner",
  ]],
  ["9", "Live Community: Monthly Class & Workspace", [
    "Monthly Live Class",
    "Monthly Workspace Session",
  ]],
];

export const Syllabus = () => (
  <section id="syllabus" data-testid="certification-syllabus" className="relative card-soft p-8 sm:p-12">
    <Ladybug spot="tr" size={22} rotate={-70} />
    <span className="eyebrow">The Syllabus</span>
    <h2 className="font-serif-h text-3xl sm:text-4xl text-[#577731] mt-4">Holistic Health Care Practitioner Certification</h2>
    <p className="mt-4 text-[#232b1b]/75 leading-relaxed">Open each module to see the lessons waiting for you on the path.</p>
    <Accordion type="multiple" className="mt-8">
      {MODULES.map(([n, title, lessons]) => (
        <AccordionItem key={n} value={n} className="border-[#dacac1]" data-testid={`syllabus-module-${n}`}>
          <AccordionTrigger className="text-left hover:no-underline py-5">
            <span className="flex items-baseline gap-4">
              <span className="font-serif-h text-2xl text-[#b6689a] w-24 shrink-0">Module {n}</span>
              <span className="font-serif-h text-xl sm:text-2xl text-[#232b1b]">{title}</span>
            </span>
          </AccordionTrigger>
          <AccordionContent>
            <ul className="space-y-3 pl-0 sm:pl-28 pb-2">
              {lessons.map((l) => (
                <li key={l} className="flex gap-3 text-[#232b1b]/80"><span className="text-[#b6689a]">✦</span>{l}</li>
              ))}
            </ul>
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </section>
);
